export default class Conversion {
    target = 'text-to-image';
    category = 'operation';
    options = {
        width: 1024,
        height: 1024,
        style: 'photorealistic',
        allow_multiple_outputs: true,
        cfg_scale: 7,
        num_inference_steps: 20,
    }

    constructor() {
    }
}